import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const PointWithLabelRoad = ({label, time, children, subtitle}) => {
  const styles = {
    content: {
      display: 'flex'
    },
    container: {
      display: 'flex',
      width: '100%',
      height: 'max-content',
      alignItems: 'center'
    },
    leftContainer: {
      display: 'flex',
      width: '15%',
      justifyContent: 'center'
    },
    middleContainer: {
      display: 'flex',
      width: time ? '15%' : '10%',
      justifyContent: time && 'center'
    },
    rightContainer: {
      display: 'box',
      width: time ? '70%' : '90%',
    },
    label: {
      fontSize: '.9em',
      textWrap: 'wrap-text'
    },
    subtitleContainer: {
      display: 'flex'
    },
    subtitle: {
      fontSize: '.8em'
    }
  };
  return (
    <Box sx={styles.container}>
      {time && (
        <Box sx={styles.leftContainer}>
          <Typography sx={styles.label}>{time}</Typography>
        </Box>
      )}
      <Box sx={styles.middleContainer}>
        {children}
      </Box>
      <Box sx={styles.rightContainer}>
        <Typography sx={styles.label}>{label}</Typography>
        {subtitle && (
          <Typography sx={styles.subtitle}>{subtitle}</Typography>
        )}
      </Box>
    </Box>
  );
};